<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="laccounts-organization-name" class="control-label">Organization Name:</label>
                    <input id="laccounts-organization-name" type="text" class="form-control"
                           v-model="accounts.organizationName" readonly="readonly">
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="laccounts-activation-date" class="control-label">Activation Date:</label>
                    <date-picker v-model="activationDate"
                                 id="laccounts-activation-date"
                                 lang="en"
                                 :value-type="'format'"
                                 :confirm="false"
                                 prefix-class="xmx"
                                 :disabled="true"
                                 :format="calendarFormat">
                    </date-picker>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="laccounts-system-id" class="control-label">System ID:</label>
                    <input id="laccounts-system-id" type="text" class="form-control" v-model="accounts.systemId"
                           readonly="readonly">
                </div>
            </div>
        </div>
        <hr>

        <div class="portlet-body" style="padding-top: 12px">
            <vue-good-table
                    :columns="columns"
                    :rows="programs"
                    :pagination-options="{enabled: true}"
                    v-if="programs.length"
            >
                <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field=='status'">

                        <span class="label label-sm"
                              :class="[props.row.status == 1 ? 'label-warning' : 'label-danger']"> {{ props.row.status == 1 ? 'Active' : 'Disabled' }} </span>
                    </span>
                    <span v-else-if="props.column.field == 'creation_date.date'">
                    {{ props.row.creation_date.date | formatDateModalNoTimeZone }}
                    </span>
                    <span v-else-if="props.column.field == 'action'">
                        <actions-menu>
                          <actions-menu-item
                            title="Edit"
                            icon="fa-edit"
                            @click.prevent="showEditProgramModal(props.row.id, props.row.name)"
                          />
                          <actions-menu-item
                            v-if="props.row.status === 1"
                            title="Disable"
                            icon="fa-remove"
                            @click="updateStatus(props.row.id, 0)"
                          />
                          <actions-menu-item
                            v-if="props.row.status === 0"
                            title="Activate"
                            icon="fa-check"
                            @click="updateStatus(props.row.id, 1)"
                          />
                        </actions-menu>
                    </span>
                    <span v-else>{{props.formattedRow[props.column.field]}}</span>
                </template>
            </vue-good-table>
            <div class="not-found-results" v-else>
                <h4>No programs found.</h4>
            </div>

            <div class="clearfix"></div>
            <div style="margin-top:20px">
                <button class="btn green pull-right" @click="showCreateProgramModal">Create Program</button>
            </div>
            <div class="clearfix"></div>
        </div>

        <div id="create-program-modal" class="modal fade" role="dialog" aria-hidden="true">
            <div class="modal-dialog" style="max-width: 400px">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                        <h4 class="modal-title">CREATE NEW PROGRAM</h4></div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label class="control-label">Program Name</label>
                            <input type="text" class="form-control" v-model="newProgramName">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn green" @click.prevent="createProgram" data-style="expand-left">Create
                            Program
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div id="edit-program-modal" class="modal fade" role="dialog" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                        <h4 class="modal-title">EDIT PROGRAM NAME</h4></div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label class="control-label">Program Name</label>
                            <input type="text" class="form-control" v-model="editProgramName">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn green" @click.prevent="editProgram" data-style="expand-left">Save</button>
                        <button class="btn default" data-dismiss="modal" aria-hidden="true">Cancel</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {HTTP, getUserInfo} from "@/http-common";
    import DatePicker from 'vue2-datepicker';
    import ActionsMenu from "./reusables/ActionsMenu";
    import ActionsMenuItem from "./reusables/ActionsMenuItem";

    export default {
        data() {
            return {
                haveResults: false,
                search: '',
                columns: [
                    {
                        label: 'Program Name',
                        field: 'name',
                        filterOptions: {enabled: true}
                    },
                    {
                        label: 'Program Status',
                        field: 'status',
                        filterOptions: {enabled: true}
                    },
                    {
                        label: 'Creation Date',
                        field: 'creation_date.date',
                        filterOptions: {enabled: true}
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        filterOptions: {enabled: false}
                    }
                ],
                programs: [],
                actionProgramId: null,
                newProgramName: '',
                editProgramName: '',
                accountsId: null
            }
        },
        components: {
            DatePicker,
            ActionsMenu,
            ActionsMenuItem
        },
        computed: {
            ...mapGetters({
                logged: 'getUser',
                accounts: 'account',
                user: 'currentUser'
            }),
            calendarFormat() {
                return getUserInfo('date_format');
            },
            activationDate: {
                get: function () {
                    if (this.accounts.activationDate != null) {
                        return this.$options.filters.formatDateModal(this.accounts.activationDate['date']);
                    }
                },
                set: function () {
                }
            }
        },
        mounted() {
            this.accountsId = this.$route.params.casemgrid;
            $('#create-program-modal').on('hidden.bs.modal', () => {
                this.newProgramName = '';
            });

            $('#edit-program-modal').on('hidden.bs.modal', () => {
                this.editProgramName = '';
            });

            this.fetchPrograms();

        },
        methods: {
            showCreateProgramModal() {
                $('#create-program-modal').modal('show');
            },
            showEditProgramModal(programId, programName) {
                this.actionProgramId = programId;
                this.editProgramName = programName;
                $('#edit-program-modal').modal('show');
            },
            createProgram() {
                HTTP.post('/programs/create', {
                    account_id: this.accountsId,
                    name: this.newProgramName
                }).then(response => {
                    if(response.data.status == 'success') {
                        this.$notify('Program created!');
                        this.fetchPrograms();
                        this.$emit('program-created', {'id': response.data.data.program_id,'name' : this.newProgramName });
                        $('#create-program-modal').modal('hide');
                    }
                }).catch(error => {
                    console.log(error);
                })
            },
            updateStatus(programId, status) {
                HTTP.post('/programs/update', {
                    id: programId,
                    status: status
                }).then(response => {
                    if(response.data.status == 'success') {
                        this.$notify('Status changed');
                        this.fetchPrograms();
                    }
                }).catch(error => {
                    console.log(error);
                });
            },
            editProgram() {
                HTTP.post('/programs/update', {
                    id: this.actionProgramId,
                    name: this.editProgramName
                }).then(response => {
                    if(response.data.status == 'success') {
                        this.$notify('Program updated!');
                        this.fetchPrograms();
                        $('#edit-program-modal').modal('hide');
                    }
                }).catch(error => {
                    console.log(error);
                });
            },
            fetchPrograms() {
                if(this.accountsId){
                    HTTP.get('/accounts/' + this.accountsId + '/programs').then((response) => {
                        this.programs = response.data.data.programs;
                    }).catch((error) => {
                        console.log(error);
                    })
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// Programs.vue?230db9d0